import { configureStore } from '@reduxjs/toolkit';
import dataReducer from './features/dataSlices';
import translationReducer from './features/translationReducer';
import fileNameReducer from './features/currFileName';

export const localStore = configureStore({
  reducer: {
    data: dataReducer,
    translations: translationReducer,
    currfileName: fileNameReducer
  }
});